/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createRegion } from '../fn/region/create-region';
import { CreateRegion$Params } from '../fn/region/create-region';
import { deleteRegion } from '../fn/region/delete-region';
import { DeleteRegion$Params } from '../fn/region/delete-region';
import { getRegion } from '../fn/region/get-region';
import { GetRegion$Params } from '../fn/region/get-region';
import { getRegions } from '../fn/region/get-regions';
import { GetRegions$Params } from '../fn/region/get-regions';
import { Region } from '../models/region';
import { updateRegion } from '../fn/region/update-region';
import { UpdateRegion$Params } from '../fn/region/update-region';

@Injectable({ providedIn: 'root' })
export class RegionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRegions()` */
  static readonly GetRegionsPath = '/region';

  /**
   * Gets all regions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRegions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegions$Response(params?: GetRegions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Region>>> {
    const obs = getRegions(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all regions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRegions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegions(params?: GetRegions$Params, context?: HttpContext): Observable<Array<Region>> {
    const resp = this.getRegions$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Region>>): Array<Region> => r.body)
    );
  }

  /** Path part for operation `createRegion()` */
  static readonly CreateRegionPath = '/region';

  /**
   * Creates a new region [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRegion()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createRegion$Response(params?: CreateRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
    const obs = createRegion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new region [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRegion$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createRegion(params?: CreateRegion$Params, context?: HttpContext): Observable<Region> {
    const resp = this.createRegion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Region>): Region => r.body)
    );
  }

  /** Path part for operation `getRegion()` */
  static readonly GetRegionPath = '/region/{id}';

  /**
   * Gets the specified region.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRegion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegion$Response(params: GetRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
    const obs = getRegion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified region.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRegion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegion(params: GetRegion$Params, context?: HttpContext): Observable<Region> {
    const resp = this.getRegion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Region>): Region => r.body)
    );
  }

  /** Path part for operation `updateRegion()` */
  static readonly UpdateRegionPath = '/region/{id}';

  /**
   * Updates the specified region [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRegion()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRegion$Response(params: UpdateRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
    const obs = updateRegion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified region [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRegion$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRegion(params: UpdateRegion$Params, context?: HttpContext): Observable<Region> {
    const resp = this.updateRegion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Region>): Region => r.body)
    );
  }

  /** Path part for operation `deleteRegion()` */
  static readonly DeleteRegionPath = '/region/{id}';

  /**
   * Deletes the specified region [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRegion()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRegion$Response(params: DeleteRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteRegion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified region [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRegion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRegion(params: DeleteRegion$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteRegion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
